<template>
	<div class="dictionaryManage">
		<div class="headerBox">
			<span>字典列表</span>
			<div style="position: absolute;top:4px;right:0">
				<!--<el-button type="primary" plain @click="batchDeleteClick()" class="addButtonClass">批量删除</el-button>-->
				<el-button type="primary" plain class="addButtonClass" @click="exportClick">导出字典</el-button>
				<el-button type="primary" plain @click="importClick()" class="addButtonClass">导入字典</el-button>
				<el-button type="primary" plain @click="addClick()" class="addButtonClass">新建字典</el-button>
				<el-button type="primary" plain @click="classfiyClick()" class="addButtonClass">字典分类</el-button>
			</div>
		</div>
		<div class="tableBox">
			<el-table :data="tableData" style="width: 100%" v-loading="loading" @selection-change="handleSelectionChange">
				<el-table-column label="序 号" width="70">
					<template slot-scope="scope"><span style="padding-left: 4px;">{{(pageIndex-1)*pageSize+scope.$index+1}}</span></template>
				</el-table-column>
				<!--<el-table-column label="选取" type="selection" width="70" style="height:20px">-->
				</el-table-column>
				<el-table-column prop="title" label="名称" min-width="2%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">名称</span>
					</template>
				</el-table-column>
				<el-table-column prop="lowerLevel" label="所属一级分类" min-width="5%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">所属一级分类</span>
					</template>
				</el-table-column>
				<el-table-column prop="lowerLevel2" label="所属二级分类" min-width="6%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">所属二级分类</span>
					</template>
				</el-table-column>
				<el-table-column prop="" label="操作" min-width="2%">
					<template slot="header" slot-scope="scope">
						<span style="vertical-align: middle;">操作</span>
					</template>
					<template slot-scope="scope">
						<a class="editClass" @click.prevent="addClick(scope.row.id,scope.row)">编辑</a>
					</template>
				</el-table-column>
			</el-table>
		</div>
		<div class="pagination">
			<el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[20, 50, 100, 200]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total" v-if="total>20">
			</el-pagination>
		</div>
		<!--新建弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible" :width="dialogWidth" :close-on-click-modal="false">
			<div style="position: relative;">
				<el-form style="width:70%">
					<el-form-item label="名称" label-width="20%" style="position: relative;">
						<el-input type="text" v-model="titleValue" autocomplete="off" style="width:90%" @change="titleChange"></el-input>
					</el-form-item>
				</el-form>
				<div class="conentClass">
					<div class="titleBox">
						<div class="leftBox"></div>
						<div style="display: inline-block;" @click="collapseClick()">
							<img src="../../assets/collapseImg.png" alt="" v-if="!upShow" />
							<img src="../../assets/collapseImg.png" alt="" class="upImg" v-if="upShow" />
						</div>
					</div>
					<div class="tabBox">
						<el-collapse v-model="activeNames" @change="handleChange">
							<el-collapse-item title="电表" :name="index" v-for="(item,index) in title_categoryData" :key='index'>
								<template slot="title">
									<el-checkbox @change="checkedRadioChange(item.id,item.checked)" v-model="item.checked">{{item.title}}</el-checkbox>
									<i :class="judgeActive('1')!==-1? 'downArrow1':'downArrow2'"></i>
								</template>
								<div class="tab_li2" v-for="items in item.children">
									<el-checkbox @change="checkedRadioChange(items.id,items.checked)" v-model="items.checked">{{items.title}}</el-checkbox>
								</div>
							</el-collapse-item>
						</el-collapse>
					</div>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible=false" class="cancle">取消</el-button>
				<el-button @click="save()" class="confrim" type="primary">立即创建</el-button>
			</div>
		</el-dialog>
		<!--导入弹窗-->
		<el-dialog :title="title" :visible.sync="dialogFormVisible2" :width="dialogWidth" :close-on-click-modal="false">
			<div style="position: relative;">
				<div class="uploadClass">
					<el-upload class="upload-demo" ref="upload" :action="http+'/zkep2/upload/upload'" :on-preview="handlePreview" :on-remove="handleRemove" :file-list="fileList" :on-change="onChange" :auto-upload="true" accept=".xls,.xlsx" :on-success="onSuccess" :before-upload="beforeUpload">
						<button class="selectFile" slot="trigger" size="small" type="primary" id="fileName">选择文件</button>
						<span class="weiUpload" v-if="fileList.length==0">未选择任何文件</span>
					</el-upload>
				</div>
				<div class="titleBox">
					<div class="leftBox"></div>
					<div style="display: inline-block;" @click="collapseClick()">
						<img src="../../assets/collapseImg.png" alt="" v-if="!upShow" />
						<img src="../../assets/collapseImg.png" alt="" class="upImg" v-if="upShow" />
					</div>
				</div>
				<div class="tabBox">
					<el-collapse v-model="activeNames" @change="handleChange">
						<el-collapse-item title="电表" :name="index" v-for="(item,index) in title_categoryData" :key='index'>
							<template slot="title">
								<el-checkbox @change="checkedRadioChange(item.id,item.checked)" v-model="item.checked">{{item.title}}</el-checkbox>
								<i :class="judgeActive('1')!==-1? 'downArrow1':'downArrow2'"></i>
							</template>
							<div class="tab_li2" v-for="items in item.children">
								<el-checkbox @change="checkedRadioChange(items.id,items.checked)" v-model="items.checked">{{items.title}}</el-checkbox>
							</div>
						</el-collapse-item>
					</el-collapse>
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible2=false" class="cancle">取消</el-button>
				<el-button @click="improtSave()" class="confrim" type="primary">立即创建</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { mapGetters, mapActions } from 'Vuex';
	import headers from '../../../static/js/headers.js'
	import dataList from '../../../static/js/dataList.js'
	import md5 from '../../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	export default {
		mounted() {
			/*当前年月*/
			var myDate = new Date();
			this.yearMonth = String(myDate.getFullYear()) + (myDate.getMonth() + 1 < 10 ? '0' + (myDate.getMonth() + 1) : myDate.getMonth() + 1)
			if(this.$route.query.fI) {
				this.pageIndex = this.$route.query.fI
			}
			if(typeof(this.pageIndex) != 'number') {
				this.pageIndex = Number(this.pageIndex)
			}
			this.getList();
			this.getTitle_categoryList();
			window.addEventListener('resize', () => {
				if(document.body.clientWidth < 767) {
					this.dialogWidth = "100%"
				} else if(document.body.clientWidth < 1200) {
					this.dialogWidth = "64%"
				} else {
					this.dialogWidth = "40%"
				}
			})
		},
		created() {
			if(document.body.clientWidth < 767) {
				this.dialogWidth = "100%"
			} else if(document.body.clientWidth < 1200) {
				this.dialogWidth = "64%"
			} else {
				this.dialogWidth = "40%"
			}
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				loading: false, //加载状态
				pageSize: 20, //每页条数
				pageIndex: 1, //当前页
				total: 0, //总条数
				tableData: [], //字典列表
				title_categoryData: [], //字典分类列表
				dialogFormVisible: false,
				dialogFormVisible2: false,
				dialogWidth: '40%',
				title: '', //弹窗标题
				searchValue: '',
				value: '',
				multipleSelection: [], //选中列表
				titleValue: '',
				activeNames: [],
				upShow: true,
				checkedAll1: false,
				checkedAll2: false,
				checkedAll3: false,
				fileList: [],
				yearMonth: '',
				notDo: false, //不执行开关
				listRow: {}, //编辑行数据
				editId: '',
				fileData: '',
				title_category_ids: ''
			}
		},
		methods: {
			//每页多少
			handleSizeChange(val) {
				this.pageSize = val;
				this.getList();
			},
			//更改页数
			handleCurrentChange(val) {
				this.pageIndex = val;
				this.getList();
			},
			//总条数
			getTotal() {
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				let config = headers.headers('getListByLimitCountWithCategory')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title/getListByLimitCountWithCategory', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.total = res.data
					} else {
						this.total = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取字典列表
			getList() {
				this.loading = true;
				var params = {
					pageSize: this.pageSize,
					pageIndex: this.pageIndex,
				}
				//console.log(params)
				let config = headers.headers('getListByLimitWithCategory')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title/getListByLimitWithCategory', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						this.tableData = res.data
						this.tableData.forEach(item => {
							item.lowerLevel = ''
							item.lowerLevel2 = ''
							item.categoryList.forEach((v, i) => {
								if(v.category_parent == 0) {
									item.lowerLevel += String(v.category_title) + '、';
									/*if(i + 2 <= item.categoryList.length) {
										item.lowerLevel += String(v.category_title) + '、';
									} else {
										item.lowerLevel += String(v.category_title);
									}*/
								} else {
									item.lowerLevel2 += String(v.category_title) + '、';
								}

							})
						})
						//console.log(this.tableData)
					} else {
						this.tableData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//获取字典分类列表
			getTitle_categoryList() {
				this.loading = true;
				var params = {
					pageSize: -1,
					pageIndex: 1,
				}
				//console.log(params)
				let config = headers.headers('getListByLimit')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title_category/getListByLimit', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.loading = false
					this.getTotal();
					//console.log(res)
					if(res.data.length > 0) {
						res.data.forEach(item => {
							item.checked = false
						})
						this.title_categoryData = this.listToTree(res.data)
					} else {
						this.title_categoryData = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//处理子列表为树状结构
			listToTree(list) {
				//遍历整个列表
				return list.filter(cur => {
					// 获取当前节点的子节点
					let children = list.filter(item => item.parent_id == cur.id);
					if(children.length > 0) {
						cur.children = children;
					}
					//只返回顶级节点
					return cur.parent_id == 0;
				});

			},
			//新增、编辑字典
			addClick(id, list) {
				this.dialogFormVisible = true
				this.emptyList();
				if(id) {
					this.title = "字典编辑"
					this.listRow = list
					this.editId = id
					this.getAllWithTitleFun(id)
					this.titleValue = list.title
				} else {
					this.title = "新建字典"
				}
			},
			//获取所有分类、并标记某字典的选择情况
			getAllWithTitleFun(editId) {
				var params = {
					title_id: editId
				}
				//console.log(params)
				let config = headers.headers('getAllWithTitle')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title_category/getAllWithTitle', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res, this.title_categoryData)
					if(res.data.length > 0) {
						this.title_categoryData.forEach(item => {
							res.data.forEach(items => {
								if(items.parent_id == 0) {
									if(items.selected == 1 && item.id == items.id) {
										item.checked = true
									}
								} else {
									item.children.forEach(v => {
										if(items.selected == 1 && v.id == items.id) {
											v.checked = true
										}
									})
								}
							})
						})
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//复选框的勾选
			checkedRadioChange(title_category_id, checked) {
				if(this.editId) {
					if(checked) {
						var timestamp = Date.parse(new Date());
						let config = headers.headers('save')
						var pass_token = config.pass_token
						var timestamp = config.timestamp
						var params = {
							title_id: this.editId,
							title_category_id: title_category_id,
							create_time: timestamp,
						}
						//console.log(params)
						axios.post(this.http + '/zkep2/title_link/save',
							qs.stringify(params), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.getList()
							} else {
								this.$message('新增失败！')
							}
						}).catch(err => {
							console.log(err)
						})
					} else {
						var timestamp = Date.parse(new Date());
						let config = headers.headers('checkOnly')
						var pass_token = config.pass_token
						var params = {
							title_id: this.editId,
							title_category_id: title_category_id,
						}
						//console.log(params)
						axios.post(this.http + '/zkep2/title_link/checkOnly',
							qs.stringify(params), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							if(res.data.id) {
								this.deleteTitleLinkById(res.data.id)
							}
						}).catch(err => {
							console.log(err)
						})
					}
				}
			},
			//删除关联
			deleteTitleLinkById(id) {
				let config = headers.headers(id)
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				var params = {}
				axios.get(this.http + '/zkep2/title_link/del/' + id, {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data == 1) {
						this.getList();
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//折叠
			collapseClick() {
				this.upShow = !this.upShow
				if(this.upShow) {
					this.activeNames = []
				} else {
					this.activeNames = []
					this.title_categoryData.forEach((item, index) => {
						this.activeNames.push(index)
					})
				}
			},
			judgeActive(data) {
				return this.activeNames.indexOf(data)
			},
			handleChange(val) {
				if(this.activeNames.length == 0) {
					this.upShow = true
				} else {
					this.upShow = false
				}
			},
			//字典光标离开触发
			titleChange() {
				var params = {
					title: this.titleValue
				}
				let config = headers.headers('getByTitle')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/title/getByTitle', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.id) {
						if(this.editId && this.titleValue == this.listRow.title) {
							this.notDo = false
							return
						}
						this.$message('该字典已存在,请重新输入字典！');
						this.notDo = true
						this.titleValue = ''
					} else {
						this.notDo = false
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//保存
			save() {
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				var manager_id = window.sessionStorage.getItem('id')
				if(this.editId) { //编辑
					var params = {
						id: this.editId,
						title: this.titleValue,
						status: 1,
						manager_id: manager_id,
						create_time: timestamp,
					}
				} else {
					var params = { //添加
						title: this.titleValue,
						status: 1,
						manager_id: manager_id,
						create_time: timestamp,
					}
				}
				//console.log(params)
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				if(this.titleValue) {
					axios.post(this.http + '/zkep2/title/save',
						qs.stringify(params), {
							headers: {
								'pass-token': pass_token,
								'time': timestamp
							}
						}).then(res => {
						//console.log(res)
						if(res.data.id) {
							this.dialogFormVisible = false
							this.getList()
							if(!this.editId) {
								this.title_linkSave(res.data.id)
							}
						} else {
							this.$message('新增失败！')
						}
					}).catch(err => {
						console.log(err)
					})
				} else {
					this.$message('请输入必填项！')
				}
			},
			//字典关联
			async title_linkSave(title_id) {
				/*创建时间的处理*/
				var timestamp = Date.parse(new Date());
				let config = headers.headers('save')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				for(var i = 0; i < this.title_categoryData.length; i++) {
					if(this.title_categoryData[i].checked) {
						const res1 = await axios.post(this.http + '/zkep2/title_link/save',
							qs.stringify({
								title_id: title_id,
								title_category_id: this.title_categoryData[i].id,
								status: 1,
								create_time: timestamp,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
							//console.log(res)
							this.getList()
							if(res.data.id) {} else {
								this.$message('新增失败！')
							}
						}).catch(err => {
							console.log(err)
						})
					}
					if(this.title_categoryData[i].children && this.title_categoryData[i].children.length > 0) {
						for(var j = 0; j < this.title_categoryData[i].children.length; j++) {
							if(this.title_categoryData[i].children[j].checked) {
								const res2 = await axios.post(this.http + '/zkep2/title_link/save',
									qs.stringify({
										title_id: title_id,
										title_category_id: this.title_categoryData[i].children[j].id,
										status: 1,
										create_time: timestamp,
									}), {
										headers: {
											'pass-token': pass_token,
											'time': timestamp
										}
									}).then(res => {
									//console.log(res)
									if(res.data.id) {
										this.dialogFormVisible2 = false
										this.getList()
									} else {
										this.$message('新增失败！')
									}
								}).catch(err => {
									console.log(err)
								})
							}
						}
					} else {
						this.getList()
						this.emptyList()
						this.dialogFormVisible2 = false
					}
				}
			},
			//清空
			emptyList() {
				this.titleValue = ''
				this.editId = ''
				this.upShow = false
				if(this.upShow) {
					this.activeNames = []
				} else {
					this.activeNames = []
					this.title_categoryData.forEach((item, index) => {
						this.activeNames.push(index)
					})
				}
				this.title_categoryData.forEach(item => {
					item.checked = false
					item.children.forEach(v => {
						v.checked = false
					})
				})
			},
			//加载的动画
			openFullScreen() {
				this.loadingAdd = this.$loading({
					lock: true,
					text: '',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0)'
				});
			},
			//导出字典
			exportClick() {
				let config = headers.headers('exportTitle')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				this.openFullScreen();
				var params = {
					path: '/mnt/xvdb/html/zkepA/storage/excel/',
				}
				//console.log(params)
				axios.get(this.http + '/zkep2/title/exportTitle', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					this.openFullScreen();
					//console.log(res)
					if(res.data.res == 1) {
						var index = res.data.file.lastIndexOf("excel");
						var fileName = res.data.file.substring(index + 6, res.data.file.length)
						//window.location.href = this.http.slice(0, -5) + '/zkepA/storage/excel' + fileName
						//window.location.href = 'http://www.380v.top' + '/storage/excel' + fileName
						//						let fileUrl = this.http.slice(0, -5) + '/zkepA/storage/excel' + fileName;
						let fileUrl = 'http://www.380v.top' + '/storage/excel' + fileName;
						let fileNameArray = fileUrl.split('/');
						let fileName = fileNameArray[fileNameArray.length - 1];
						let element = document.createElement('a');
						element.style.display = 'none';
						element.setAttribute('href', fileUrl);
						element.setAttribute('download', fileName);
						document.body.appendChild(element);
						element.click();
						document.body.removeChild(element);
						setTimeout(() => {
							this.loadingAdd.close();
							this.$message({
								type: 'success',
								message: '导出成功'
							});
						}, 3000);

					} else {
						this.$message({
							type: 'error',
							message: res.data.msg + '!'
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			/*导入字典*/
			importClick() {
				this.dialogFormVisible2 = true
				this.title = '字典导入'
				this.upShow = false
				if(this.upShow) {
					this.activeNames = []
				} else {
					this.activeNames = []
					this.title_categoryData.forEach((item, index) => {
						this.activeNames.push(index)
					})
				}
				this.title_categoryData.forEach(item => {
					item.checked = false
					item.children.forEach(v => {
						v.checked = false
					})
				})
				this.fileList = []
			},
			handleRemove() {},
			onChange(file, fileList) {
				this.fileList = []
				this.fileList.push(file)
			},
			handlePreview() {},
			onSuccess() {},
			beforeUpload(file) {
				let fd = new FormData();
				fd.append('file', file); //传文件
				fd.append('path', '/mnt/xvdb/html/zkepA/storage/upload/' + this.yearMonth); //传其他参数
				var name = this.$uuid.v1()
				var index = file.name.lastIndexOf(".");
				var type = file.name.substring(index, file.name.length);
				fd.append('fileName', name + type); //传其他参数
				let config = headers.headers('uploadFile')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/upload/uploadFile',
					fd, {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data) {
						this.fileData = res.data
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//导入字典的保存
			improtSave() {
				this.importTitletFun(this.fileData);
			},
			importTitletFun(file) {
				this.title_category_ids = ''
				var arr = []
				this.title_categoryData.forEach(item => {
					if(item.checked) {
						arr.push(item.id)
					}
					item.children.forEach(v => {
						if(v.checked) {
							arr.push(v.id)
						}
					})
				})
				this.title_category_ids = arr.join(',')
				//console.log(this.title_category_ids)
				let fd = new FormData();
				fd.append('file', file); //传文件
				fd.append('title_category_ids', this.title_category_ids); // 分类ID列表
				let config = headers.headers('importTitle')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.post(this.http + '/zkep2/title/importTitle',
					fd, {
						headers: {
							'pass-token': pass_token,
							'time': timestamp
						}
					}).then(res => {
					//console.log(res)
					if(res.data.res == 1) {
						this.getList()
						this.dialogFormVisible2 = false
					} else {
						this.$message({
							type: 'error',
							message: res.data.msg
						});
					}
				}).catch(err => {
					console.log(err)
				})
			},
			classfiyClick() {
				this.$router.push({
					path: '/dictionaryManage/dictionaryClassify',
					name: 'DictionaryClassify'
				})
			},
			/*（已弃用）*/
			//复选框触发
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			//批量删除
			batchDeleteClick() {
				if(this.multipleSelection.length > 0) {
					let config = headers.headers('save')
					var pass_token = config.pass_token
					var timestamp = config.timestamp
					this.$confirm('', '', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						message: '注意<br>' + "确认要删除吗？",
						dangerouslyUseHTMLString: true,
					}).then(() => {
						for(var i = 0; i < this.multipleSelection.length; i++) {
							axios.post(this.http + '/zkep2/title/save', qs.stringify({
								id: this.multipleSelection[i].id,
								title: this.multipleSelection[i].title + '_' + this.multipleSelection[i].id,
								status: 0,
							}), {
								headers: {
									'pass-token': pass_token,
									'time': timestamp
								}
							}).then(res => {
								//console.log(res)
								this.getList();
							}).catch(err => {
								console.log(err)
								this.$message({
									type: 'error',
									message: '删除失败!'
								});
								return
							})
						}
						this.$message({
							type: 'success',
							message: '删除成功!'
						});
					}).catch(() => {
						this.$message({
							type: 'info',
							message: '已取消删除'
						});
					});
				} else {
					this.$message({
						type: 'info',
						message: '请至少选择一条批量删除的数据!'
					});
				}
			},
		}
	}
</script>

<style>
	.dictionaryManage {
		box-sizing: border-box;
		height: 100%;
		padding: 2% 12% 0 12%;
		position: relative;
	}
	
	.dictionaryManage .headerBox {
		position: relative;
		height: 30px;
		line-height: 30px;
		padding: 6px 30px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
		font-size: 13px;
		margin-bottom: 10px;
	}
	/*element表格*/
	
	.dictionaryManage .el-table th {
		color: #000;
	}
	
	.dictionaryManage .el-table {
		font-size: 12px;
	}
	
	.dictionaryManage .el-table th,
	.dictionaryManage .el-table td,
	.dictionaryManage .el-table tr {
		background-color: #FFF;
		padding: 6px 0!important;
		text-align: left;
	}
	
	.dictionaryManage .el-table th {
		text-align: left;
		padding: 10px 0!important;
		font-weight: 400;
		color: #999;
	}
	
	.dictionaryManage .tableBox {
		padding: 0 20px;
		border: 1px solid #EEE;
		border-radius: 3px;
		background-color: #fff;
	}
	
	.dictionaryManage .editClass {
		color: #439DFD;
		margin-right: 10px;
		cursor: pointer;
	}
	
	.dictionaryManage .deleteClass {
		color: #C44979;
		cursor: pointer;
	}
	
	.dictionaryManage .el-form-item {
		margin-bottom: 12px;
	}
	
	.dictionaryManage .addButtonClass {
		padding: 10px 12px;
		font-size: 13px;
	}
	/*复选框-灰*/
	
	.dictionaryManage .el-checkbox__input.is-checked .el-checkbox__inner,
	.dictionaryManage .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #fff;
		border-color: #999!important;
	}
	
	.dictionaryManage .el-checkbox__inner:after {
		-webkit-box-sizing: content-box;
		box-sizing: content-box;
		content: "";
		border: 1px solid #999;
		border-left: 0;
		border-top: 0;
		height: 8px;
		vertical-align: middle;
		text-align: center;
	}
	
	.dictionaryManage .el-checkbox__inner {
		border: 1px solid #999!important;
		border-radius: 0;
		width: 15px;
		height: 15px;
	}
	
	@media screen and (max-width: 1500px) {
		.dictionaryManage .headerBox {
			height: 70px;
			line-height: 30px;
		}
	}
	/*element弹窗*/
	
	.dictionaryManage .el-dialog__title {
		color: #999;
	}
	
	.dictionaryManage .el-dialog__footer {
		text-align: center;
	}
	
	.dictionaryManage .pagination {
		text-align: center;
	}
	
	.dictionaryManage .conentClass {
		padding: 4px;
	}
	
	.dictionaryManage .titleBox {
		height: 30px;
		line-height: 30px;
		width: 100%;
	}
	
	.dictionaryManage .leftBox {
		display: inline-block;
		padding: 0 2%;
		width: 89%;
		color: #000;
	}
	
	.dictionaryManage .upImg {
		transform: rotate(-180deg);
	}
	
	.dictionaryManage .tabBox {
		padding: 2%;
	}
	/*折叠面板*/
	
	.dictionaryManage .el-collapse {
		border: none;
	}
	
	.dictionaryManage .collapseClass {
		color: #AFAFAF;
		font-size: 18px;
	}
	
	.dictionaryManage .el-collapse-item__header {
		background-color: #DFDEDE;
		height: 36px;
		line-height: 36px;
		padding-left: 10px;
	}
	
	.dictionaryManage .el-collapse-item__content {
		background-color: #DFDEDE;
		padding-left: 10px;
	}
	
	.dictionaryManage .el-collapse-item {
		margin-bottom: 4px;
	}
	
	.dictionaryManage .el-form-item__label {
		color: #000;
	}
	
	.dictionaryManage .el-collapse-item__arrow {
		display: none;
	}
	
	.dictionaryManage .downArrow1 {
		margin-right: 10px;
		display: inline-block;
		width: 16px;
		height: 16px;
		background-image: url(../../assets/collapseImg.png);
	}
	
	.dictionaryManage .downArrow2 {
		margin-right: 10px;
		display: inline-block;
		width: 16px;
		height: 16px;
		background-image: url(../../assets/collapseImg.png);
		transform: rotate(-180deg);
	}
	
	.dictionaryManage .el-collapse-item__header {
		justify-content: space-between;
	}
	/*复选框-蓝*/
	
	.dictionaryManage .tabBox .el-checkbox__input.is-checked .el-checkbox__inner,
	.dictionaryManage .tabBox .el-checkbox__input.is-indeterminate .el-checkbox__inner {
		background-color: #5677FC;
		border-color: #5677FC!important;
	}
	
	.dictionaryManage .tabBox .el-checkbox__inner:after {
		-webkit-box-sizing: content-box;
		box-sizing: content-box;
		content: "";
		border: 1px solid #fff;
		border-left: 0;
		border-top: 0;
		height: 8px;
		vertical-align: middle;
		text-align: center;
	}
	
	.dictionaryManage .tabBox .el-checkbox__inner {
		border: 1px solid #999!important;
		border-radius: 0;
		width: 15px;
		height: 15px;
	}
	
	.dictionaryManage .tabBox .el-checkbox__input.is-checked+.el-checkbox__label {
		color: #000;
		font-size: 13px;
	}
	
	.dictionaryManage .tabBox .el-checkbox__label {
		color: #000;
		font-size: 13px;
	}
	
	.dictionaryManage .tab_li2 {
		display: inline-block;
		padding-left: 2%;
		width: 17%;
	}
	
	.dictionaryManage .uploadClass {
		margin: 10px;
		height: 60px;
		line-height: 60px;
		background-color: #red;
	}
	
	.dictionaryManage .selectFile {
		height: 30px;
		line-height: 30px;
	}
	/*加载图标*/
	
	.el-loading-spinner {
		font-size: 46px;
	}
	
	.el-loading-spinner i {
		color: #34495e!important;
		opacity: 0.7;
	}
</style>


// WEBPACK FOOTER //
// src/components/DictionaryManage/DictionaryManage.vue